module.exports = __webpack_public_path__ + "img/18_bohle.78a4d20c.jpeg";